import React from 'react';
import { ProductHat as PackagePickerHat } from '@wix/package-picker-components';
import { observer } from 'mobx-react';
import { useHatProperties } from './useHatProperties';
import { RootStore, withInjectedRootStore } from 'providers';

interface ProductHatProps {
  isCurrentPlan: boolean;
  isOnSale: boolean;
  isRecommended: boolean;
  text?: string;
  salePercentages?: number;
  isAllProductsOnSale?: boolean;
  rootStore: RootStore;
}

const ProductHatComp: React.FC<ProductHatProps> = ({
  isCurrentPlan,
  isOnSale,
  isRecommended,
  text,
  salePercentages,
  isAllProductsOnSale,
  rootStore,
}) => {

  const hatProperties = useHatProperties({
    isCurrentPlan,
    isOnSale,
    isRecommended,
    text,
    salePercentages,
    isAllProductsOnSale,
    rootStore,
  });
  return hatProperties ? (
    <PackagePickerHat {...hatProperties} dataHook='product-hat' />
  ) : null;
};

export const ProductHat = withInjectedRootStore(observer(ProductHatComp));
